export default __webpack_public_path__ + "static/media/Live_Performance_Bg_Asset_4.dd62ccc5.png";